import { Component, OnInit } from '@angular/core';
import { ModalService, MODAL } from '../../services/modal.service';
import { BomDataHelper } from '../../services/helpers/bom-data-helper';
import { CustomerService } from '../../services/customer.service';
import { environment } from '../../../environments/environment';
import { CurrentService } from '../../services/current.service';
import { ProcessQuoteService } from '../../services/process-quote.service';
import { PrintService } from '../../services/print.service';
import { TranslateService } from '@ngx-translate/core';
import { DatasService } from '../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { getHbmAppName, getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';

@Component({
  selector: 'ng-casto-products-list',
  templateUrl: './products-list.component.html',
})
export class ProductsListComponent implements OnInit {
  public flattenBom: any;
  public beautifiedBom: any;

  public customerInfos: any;
  public projectName: string;

  public vendorEnvironment: boolean;
  public projectIsSaved: boolean;
  public printLoading: boolean;

  public quoteSystem: string = 'NC';

  constructor(
    public modalService: ModalService,
    public datas: DatasService,
    public customer: CustomerService,
    public processQuote: ProcessQuoteService,
    public current: CurrentService,
    private readonly print: PrintService,
    private readonly translate: TranslateService,
    private readonly gtm: GTM,
    private readonly router: Router
  ) {
    this.customerInfos = {
      name: customer.isLogged ? customer.fullName : '(non identifié)',
      id: customer.isLogged ? customer.userDatas.id : '-',
    };

    this.vendorEnvironment = environment.vendor;
    this.projectIsSaved = current.HBMProject;
    const bom = BomDataHelper.parseBomData(modalService.currentDatas.bom);
    this.flattenBom = BomDataHelper.extractFlatProductsList(bom);

    const result = BomDataHelper.extractBlockGroupedProductsList(bom);
    this.beautifiedBom = result?.empty && bom && !BomDataHelper.isBomUnavailableForProductList(bom) ? bom : result;

    if (environment.vendor) {
      let _rightNow = new Date();
      let currentYYYYMMDD: number = parseInt(_rightNow.toISOString().slice(0, 10).split('-').join(''));
      let storeSwitchDate: number = parseInt(this.current.vendor.store.switchDate);
      this.quoteSystem = currentYYYYMMDD < storeSwitchDate ? 'LegacyCommerce' : '.COM+';

      this.beautifiedBom.blocks.map(block => {
        block.rows.map(row => {
          row.pmm = this.datas.getPmmForEan(row.reference);
        });
      });
    }
  }

  ngOnInit(): void {
    const nbSteps = getHbmTotalSteps(this.customer.context);
    this.gtm.trackPage(`${this.router.url}/liste-dachats`, `${getHbmAppName(this.customer.context)} | Liste d'achats`, {
      stepNumber: nbSteps,
      totalSteps: nbSteps,
    });
  }

  close() {
    this.modalService.close();
  }

  get isBomEmpty(): boolean {
    return BomDataHelper.isBomUnavailableForProductList(this.beautifiedBom);
  }

  order() {
    if (this.isBomEmpty) {
      return;
    }

    let _modalId: number = MODAL.ORDER_PRODUCTS;
    this.modalService.display(_modalId, {
      bom: this.modalService.currentDatas.bom,
    });
  }

  printList() {
    if (this.isBomEmpty) {
      return;
    }

    this.printLoading = true;

    this.print.reset();
    this.print
      .addHeader(this.translate.instant('popins.products_list.print_title_' + this.customer.context))
      .then(() => {
        if (this.customer.isLogged) {
          this.print.addText(
            this.translate.instant('popins.products_list.customer_id') + ' ' + this.customerInfos.id,
            'my-3'
          );
          this.print.addText(
            this.translate.instant('popins.products_list.name') + ' ' + this.customerInfos.name,
            'my-3'
          );
        }

        this.print.addText(
          this.translate.instant('popins.products_list.project') +
            ' ' +
            (this.current.HBMProject
              ? this.current.HBMProject.name
              : this.translate.instant('popins.price_info.placeholder_project_' + this.customer.context)),
          'my-3'
        );

        let _rightNow = new Date();
        let _dateStr = _rightNow.toISOString().slice(0, 10).split('-');
        this.print.addText('Le ' + _dateStr[2] + '/' + _dateStr[1] + '/' + _dateStr[0], 'mt-3 mb-5');

        this.print.addDiv(document.querySelector('.price-table-container').cloneNode(true) as HTMLDivElement);

        this.print
          .addTable(document.querySelector('.table.product-table').cloneNode(true) as HTMLTableElement)
          .then(() => {
            let _legacy: string[] = this.translate.instant('popins.products_list.aside.disclaimer').split('<br/>');
            this.print.addText('', 'mt-5');
            _legacy.forEach(p => this.print.addText(p, 'my-3'));

            this.print.print();
            this.printLoading = false;
          });
      });
  }
}
